<template>
<div class="spackageEdit bgc">
    <div class="message" v-if="!realName">
        <el-alert title="" type="warning" show-icon :closable="false">请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容。</el-alert>
    </div>
    <div class="account-form form">
        <el-form :model="item" :rules="rules" ref="item" label-width="120px" class="demo-item" label-position="left" size="mini">
            <div class="classes blod">基本信息</div>
            <el-form-item label="专栏名称" prop="subject" class="spackageTitle">
                <el-input v-model.trim="item.subject" placeholder="请输入您要上传的专栏标题，不超过30字。" clearable maxlength="30" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="专栏封面" prop="headImage" class="upload-image">
                <upload class="headImage" ref="coverfile" :imgRule="imgRule" @setImage="setImgUrl" :uploadType="uploadType"></upload>
                <div class="el-upload__tip">
                    <div>1.建议上传尺寸1280*840，jpg或png格式，不超过2M </div>
                    <div>2.精美封面有助于增加浏览量，并有机会获得强力推荐！</div>
                </div>
            </el-form-item>
            <el-form-item label="专栏简介" class="spackageDesc" prop="description">
                <el-input v-model.trim="item.description" placeholder="请输入简介，不超过80字。" clearable maxlength="80" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="专栏详情" prop="details" class="spackageDetails">
                <uEditor :content="item.content" ref="uEditor" @getUEditorContent="getUEditorContent"></uEditor>
            </el-form-item>
            <div class="classes blod">商品信息</div>
            <el-form-item label="售卖方式">
                    <promotionMsg ref="promotionMsg" @changeWay="changeWay"></promotionMsg>
            </el-form-item>
            <el-form-item label="商品分组" class="commodityGroup">
                <el-select v-model="item.divisionids" collapse-tags style="width:368px;" multiple>
                        <el-option v-for="item in goodsGroup" :label="item.name" :key="item.name" :value="item.innerid"></el-option>
                </el-select>
                <span class="refresh" @click="getCommodityGroup">刷新</span>
                <span class="goCommodityGroup" @click="goGoodsGroup">前往商品分组</span>
                <p class="groupTips">商品分组可辅助你更好地管理商品</p>
            </el-form-item>
            <div class="classes blod">上架设置</div>
            <el-form-item label="上架方式" prop="putawaySet" label-width="120px" class="putawaySet">
                <!--<el-radio-group v-model="item.onlinetype">-->
                    <!--<el-radio :label="1">立即上架</el-radio>-->
                    <!--<el-radio :label="2">定时上架<el-date-picker placeholder='请选择定时上架时间' v-model.trim="item.onlinetime" value-format="yyyy-MM-dd HH:mm:ss" :disabled="String(item.onlinetype) !== '2'"  type="datetime"></el-date-picker></el-radio>-->
                    <!--<el-radio :label="3">暂不上架</el-radio>-->
                <!--</el-radio-group>-->
                <shalfSetting :item="item" ref="shalfSetting"></shalfSetting>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('item')" :disabled="submitBtn">提交</el-button>
                <el-button type="" @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</div>
</template>

<script>
import Upload from 'base/upload/upload'
import UEditor from 'base/uEditor/uEditor'
import PromotionMsg from 'base/promotionMsg/promotionMsg'
import {formatCheckView, formatCheckList, formatFileInfo} from '@/common/js/tools'
import {commodityGroup} from '@/api/imageText'
import {editSpackageMsg, newSpackageMsg, spackageItemMsg} from '@/api/spackageApi'
import {mapActions, mapGetters} from 'vuex'
import ShalfSetting from 'base/promotionMsg/shalfSetting'
import $ from 'jquery'
export default {
    name: 'spackageEdit',
    data() {
        // 检查封面图片
        let checkHeadImage = (rule, value, callback) => {
            if (!this.item.coverPicture.furl) {
                callback(new Error('请选择封面图片'))
            } else {
                callback()
            }
        }
        // 检查专题详情
        let checkDetails = (rule, value, callback) => {
            if (!this.item.content) {
                callback(new Error('请输入专题详情'))
            } else {
                callback()
            }
        }
        // 检查上架方式
        let checkOnlinetype = (rule, value, callback) => {
            if (!this.item.onlinetype) {
                callback(new Error('请选择上架方式'))
            } else {
                callback()
            }
        }
        // 检查上架时间
        let checkOnlineTime = (rule, value, callback) => {
            if (this.item.onlinetype === 2) {
                if (!this.item.onlinetime) {
                    callback(new Error('请选择上架时间'))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        return {
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            realName: false,
            item: {
                innerid: this.$route.innerid ? this.$route.innerid : '',
                subject: '', // 专题名称
                content: '', // 专题详情
                feetype: 1, // 售卖方式
                onlinetype: 1, // 上架方式
                onlinetime: '', // 上架时间
                description: '', // 专题简介
                uprice: '', // 划线价格
                saleprice: '', // 商品价格
                divisionids: [], // 商品分组
                isplatform: true,
                ispublic: true,
                coverPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                } // 专题封面
            },
            feetype: 1,
            submitBtn: false, // 提交按钮是否禁用
            goodsGroup: [], // 请求来的数据  商品分组
            rules: {
                subject: [
                    {required: true, message: '请输入专题名称', trigger: 'blur'},
                    {min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur'}
                ],
                headImage: [
                    {validator: checkHeadImage, trigger: 'blur'}
                ],
                details: [
                    {validator: checkDetails, trigger: 'blur'}
                ],
                putawaySet: [
                    {validator: checkOnlinetype, trigger: 'blur'}
                ],
                onlinetypeTime: [
                    {validator: checkOnlineTime, trigger: 'blur'}
                ],
                description: [
                    {min: 0, max: 80, message: '长度在80个字符', trigger: 'blur'}
                ]
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 2,
                width: 500,
                height: 500
            }
        }
    },
    created() {
        if (this.$route.query.innerid) {
            this.getItemSpackageMsg(this.$route.query.innerid)
        }
    },
    mounted() {
        this.getCommodityGroup()
    },
    methods: {
        getUEditorContent(content) {
            this.item.content = content
        },
        submitForm(formName) {
            let shalfSetting = this.$refs.shalfSetting.checkShalfSetting()
            this.$refs.promotionMsg.$refs.sellWayForm.validate((v) => {
                this.$refs[formName].validate((valid) => {
                    if (valid && v && shalfSetting) {
                        this.$confirm('请确认您的输入信息是否完整正确？', '提交内容', {
                            cancelButtonText: '取消',
                            confirmButtonText: '确定',
                            closeOnClickModal: false
                        }).then(() => {
                            this.submitBtn = true
                            let tmpList = formatCheckList(JSON.parse(JSON.stringify(this.$refs.promotionMsg.item.checkView)))
                            let obj = $.extend(true, {}, Object.assign({}, this.item, this.$refs.promotionMsg.item))
                            obj.checkView = JSON.stringify(tmpList)
                            obj.coverPicture = formatFileInfo(obj.coverPicture)
                            obj.isplatform = obj.isplatform ? 1 : 0
                            obj.ispublic = obj.ispublic ? 1 : 0
                            if (!obj.divisionids) {
                                obj.divisionids = []
                            }
                            obj.divisionids = obj.divisionids.join(',')
                            if (this.item.innerid) {
                                this.updateSpackageMsg(obj)
                            } else {
                                this.addSpackagelMsg(obj)
                            }
                        }).catch(() => {
                            this.submitBtn = false
                        })
                    } else {
                        this.submitBtn = false
                        this.$message.error('请完善您的数据！')
                        return false
                    }
                })
            })
        },
        addSpackagelMsg(obj) {
            this.setLoading(true)
            newSpackageMsg({
                data: obj,
                success: data => {
                    if (data.code === '000') {
                        this.setLoading(false)
                        this.$message({
                            type: 'success',
                            message: '新建成功'
                        })
                        this.$router.push({path: '/cms/spackage/spackageList', query: {refresh: '1'}})
                    } else {
                        this.setLoading(false)
                        this.$message.error('新建失败')
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        updateSpackageMsg(obj) {
            this.setLoading(true)
            editSpackageMsg({
                data: obj,
                success: data => {
                    if (data.code === '000') {
                        this.setLoading(false)
                        this.$message({
                            type: 'success',
                            message: '修改成功'
                        })
                        this.$router.push({path: '/cms/spackage/spackageList', query: {refresh: '0'}})
                    } else {
                        this.setLoading(false)
                        this.$message.error('修改失败')
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        setImgUrl(img) {
            this.item.coverPicture = img
        },
        getCommodityGroup() {
            this.setLoading(true)
            commodityGroup({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.goodsGroup = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取单个专题信息
        getItemSpackageMsg(innerid) {
            this.setLoading(true)
            spackageItemMsg({
                data: {innerid},
                success: data => {
                    this.setLoading(false)
                    if (data.data.checkView && data.data.checkView !== '') {
                        data.data.checkView = formatCheckView(JSON.parse(data.data.checkView), this.$refs.promotionMsg.item.checkView)
                    }
                    if (data.data.divisionids && data.data.divisionids !== '') {
                        // data.data.divisionids = JSON.parse(data.data.divisionids)
                    } else {
                        data.data.divisionids = []
                    }
                    this.item = data.data
                    delete this.item.checkView
                    this.item.coverPicture = JSON.parse(this.item.coverPicture)
                    this.item.innerid = innerid
                    this.$refs.promotionMsg.setItem(data.data)
                    this.$refs.uEditor.init(this.item.content)
                    this.item.isplatform = this.item.isplatform === 1
                    this.item.ispublic = this.item.ispublic === 1
                    this.$refs.coverfile.setImage(this.item.coverPicture.furl)
                    if (this.item.covertpurl) {
                        this.$refs.covertpfile.setImage(this.item.covertpurl)
                    }
                },
                error: data => {
                    this.setLoading(true)
                    this.$message.error(data.msg)
                }
            })
        },
        // 前往商品分组
        goGoodsGroup() {
            let goPath = window.location.origin + '/shopMgt/goods/goodsGroup'
            window.open(goPath)
        },
        ...mapActions([
            'setLoading'
        ]),
        cancel() {
            this.$router.push('/cms/spackage/spackageList')
        },
        changeWay(type) {
            this.feetype = type
        }
    },
    filters: {},
    watch: {
    },
    computed: {},
    components: {
        Upload,
        UEditor,
        PromotionMsg,
        ShalfSetting
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
@import "~common/scss/mixin";
.spackageEdit {
    .message{
        margin-bottom: 20px;
    }
    .upload-image{
        .el-form-item__content{
            @include flexBox(space-between)
        }
    }
    .headImage .avatar-uploader{
        box-sizing: border-box;
        width: 320px;
        height: 180px;
    }
    .el-upload__tip{
        color: $tcolor-grey;
        align-self: flex-end;
        margin-left: 20px;
        flex-grow: 1;
    }
    .spackageTitle, .spackageDesc{
        .el-form-item__content{
            width: 800px;
        }
    }
    .upload-image, .spackageDetails, .putawaySet, .sellWaySet, .spackagePriceBox{
        .el-form-item__label::after{
            content: "*";
            color: #F56C6C;
            margin-left: 4px;
        }
    }
    .upload-image{
        .el-form-item__error{
            padding-top: 4px;
        }
    }
    .sellWayForm{
        padding: 15px 24px;
        width: 800px;
        box-sizing: border-box;
        .spackagePriceBox{
            margin-left: 85px;
            .spackagePrice{
                .el-input{
                    width: 230px;
                }
                span{
                    margin-left: 14px;
                }
            }
        }
        .share{
            .el-form-item__label::after{
                content: "";
            }
        }
        .articlePrice,.projectPrice{
            display:flex;
            .el-input{
                width: 230px;
            }
            span{
                margin-left: 14px;
            }
        }
        .articlePriceBox{
            margin-left: 85px;
            .el-form-item__label::after{
                content: "*";
                color: #F56C6C;
                margin-left: 4px;
            }
        }
        .projectPriceBox{
            margin-left: 85px;
            .el-form-item__label{
                margin-top: 15px;
            }
            .projectPrice{
                margin-top: 15px;
            }
        }
        .tips{
            margin-left: 85px;
            color:#909399;
            a{
                color: #409EFF;
            }
        }
        .shareTips{
            color: #909399;
            margin-left: 10px;
        }
        .promotionSet{
            .helpSell{
                display: flex;
                margin-top: 15px;
                .el-input{
                    width: 74px;
                    input{
                        height: 32px !important;
                    }
                }
                .el-form-item__label{
                    padding: 0;
                    margin-left: 10px;
                }
            }
            .flashSale{
                display: flex;
                margin-top: 15px;
                .el-form-item__label{
                    padding: 0;
                    margin-left: 10px;
                }
            }
            .allReduce{
                display: flex;
                margin-top: 15px;
                .el-input{
                    width: 74px;
                    input{
                        height: 32px !important;
                    }
                }
                .el-form-item__label{
                    padding: 0;
                    margin-left: 10px;
                }
            }
            & > .el-form-item__label{
                padding-top: 16px;
                padding-right: 0;
            }
            .el-input{
                width: 85px !important;
            }
            .el-date-editor{
                width: 222px !important;
            }
        }
        .el-form-item__label{
            margin-left: 0!important;
        }
        .reduceMg{
            .el-form-item__label{
                width: 60px!important;
            }
            .el-form-item__content{
                margin-left: 65px !important;
            }
        }
        .el-form-item__content{
            margin-right: 10px;
        }
    }
    .commodityGroup{
        .refresh{
            color: #409EFF;
            margin-left: 18px;
            cursor: pointer;
        }
        .goCommodityGroup{
            margin-left: 22px;
            cursor: pointer;
            color: #409EFF;
        }
        .groupTips{
            font-size: 14px;
            color: #909399;
        }
    }
    .putawaySet{
        .el-radio-group{
            margin-top: 6px;
        }
        .el-radio{
            display: block;
            .el-date-editor{
                margin-left: 28px;
            }
        }
    }
}
</style>
